import type { LocationPosition } from './location-position.interface';

export interface cv_LocationType {
    C_LocationType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    LocationPositions: LocationPosition[];
    LocationType: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
